/**
 * Client side view of a CmsAnalyticsSession, as sent to `/api/public/analytics/sessions/init`.
 * Only holds what the client knows: the server applies the model defaults (medium, excluded, weekDay...),
 * so unset fields are left out of the body to let those defaults apply (and to never overwrite the stored
 * values of a resumed session).
 */
export default class AnalyticsSession {
    id;
    dealerid;
    websiteId;
    source;
    medium;
    campaign;
    excluded;
    utms;
    page;
    userAgent;
    origin;
    language;

    constructor(data = {}) {
        for (const key of Object.keys(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }

    toBody() {
        const body = {};
        for (const [key, value] of Object.entries(this)) {
            if (value !== undefined && value !== null) {
                body[key] = value;
            }
        }
        return body;
    }
}
